import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CompanyLogoIcon from './svg/CompanyIcon';
import { formatAbn } from '../lib/formatter';

const useStyles: any = makeStyles((theme: any) => ({
  root: {
    backgroundColor: theme.palette.warning.light,
    borderBottom: `1px solid ${theme.palette.grey['300']}`,
    padding: theme.spacing(2, 0),
  },
  companyIcon: {
    height: 35,
    width: 35,
  },
  abnLabel: {
    fontWeight: 500,
  },
  iconContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
}));

interface Props {
  name: string;
  abn: string;
}

const AccountInfoHeader = (props: Props) => {
  const classes = useStyles();
  const { name, abn } = props;

  return (
    <Grid container className={classes.root}>
      <Grid item xs={2} className={classes.iconContainer}>
        <CompanyLogoIcon className={classes.companyIcon} viewBox='0 0 47 47' />
      </Grid>
      <Grid item xs={10}>
        <Typography variant='h5'>{name}</Typography>
        <Typography variant='body1' component='span' className={classes.abnLabel}>
          ABN&nbsp;
        </Typography>
        <Typography variant='body1' component='span'>
          {formatAbn(abn)}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default AccountInfoHeader;
